var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-card',{attrs:{"title":"Free Goods"}},[_c('div',{staticClass:"vx-col md:w-1/1 w-full"},[_c('all')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }